<template>
    <div class="gray-back" style="height: 100%" >
        <div class="box">
            <van-tabs v-model="active" class="tab-nav" sticky @click="onStatusChange">
                <van-tab title="全部"></van-tab>
                <van-tab title="申报中"></van-tab>
                <van-tab title="申报成功"></van-tab>

                <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <div class="row-list" v-for="(order, index) in list" :key="index"
                             @click="goDetail(order)">
                            <div class="justify-space-flex row-title">
                                <div class="title-left flex-start gray">
                                    <img class="row-title-img" src="https://static.dierqudao.com/images/dinghuoxitong/icon-date.png" alt="">
                                    <span>{{order.create_time_str}} 申报</span>
                                </div>
                                <!--<div v-if="order.memberstatus==1" class="title-right gray">-->
                                    <!--秩序册-->
                                <!--</div>-->
                                <!--<div v-else-if="order.memberstatus==2" class="title-right gray">-->
                                    <!--项目填写-->
                                <!--</div>-->
                                <!--<div v-else-if="order.memberstatus==3" class="title-right gray">-->
                                    <!--人员统计-->
                                <!--</div>-->
                                <!--<div v-else-if="order.memberstatus==4" class="title-right gray">-->
                                    <!--住宿统计-->
                                <!--</div>-->
                                <!--<div v-else-if="order.memberstatus==5" class="title-right">-->
                                    <!--等待付款-->
                                <!--</div>-->
                                <!--<div v-else-if="order.memberstatus==6" class="title-right green">-->
                                    <!--报名成功-->
                                <!--</div>-->
                            </div>
                            <div class="justify-space-flex row-goods"  >
                                <div class="row-left flex-start">
                                    <div class="goods-detail">
                                        <div class="goods-name" v-if="order.member_list.length>0">
                                            <span v-for="(member,mkey)  in order.member_list" v-if="mkey<4" :key="mkey">{{member.name}} </span>
                                            等{{order.members}}人报名
                                        </div>
                                        <div class="goods-name" v-else>
                                            暂无人员报名
                                        </div>
                                        <div class="goods-weight gray-light">
                                            {{order.danwei}}
                                        </div>
                                    </div>
                                </div>
                                <div class="row-right">
                                    <div class="goods-price" v-show="order.order_price>0"><span>¥</span>{{order.order_price}}</div>
                                    <div class="goods-num gray-light">人数 {{order.members}}</div>
                                </div>
                            </div>
                            <div class="row-btn">
                                <div class="look-order"  >查看详情</div>
                                <!--<div class="invite-btn">邀请好友来拼团</div>-->
                            </div>
                        </div>
                    </van-list>
                </van-pull-refresh>
            </van-tabs>



        </div>

        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round v-rblink="{name:'ExameApplyFormBasic'}" >新增申报</van-button>
        </div>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 50px;*/
        background: rgba(248,248,248,1);
        min-height: 90vh;
    }
    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }
    .van-pull-refresh{
        margin-top: 0.3rem
    }
    .title-left span{
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
    }
    .normal-btn {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        width:75px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.5rem;
    }

    .count_edit {
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-list {
        border-bottom: 0.1rem solid #EFEFEF;
        background: #fff;
        margin: 0.2rem;
        border-radius: 0.2rem;
    }

    .row-title-img {
        width: 0.4rem;
        height: 0.4rem;
        margin-right: 0.1rem;
        object-fit: cover;
    }

    .row-title {
        padding: 0.1rem 0.33rem;
    }

    .title-right {
        color: #FD2840;
    }



    .row-left {
        width: 80%;
    }

    .row-right {
        text-align: center;
    }

    .goods-detail {
        width: 72%;
    }

    .row-left-img {
        width: 1.44rem;
        height: 1.44rem;
        border-radius: 5px;
        margin-right: 0.2rem;
        object-fit: cover;
    }

    .row-goods {
        padding: 0.2rem 0.3rem;
        border-bottom: 1px solid #EFEFEF;
    }

    .goods-name {
        font-size: 12px;
        margin-bottom: 0.6rem;
    }

    .goods-price {
        font-size: 16px;
        margin: 0.1rem 0 0.6rem;
        font-family:PingFangSC-Medium,PingFang SC;
        font-weight:500;
        color:rgba(253,40,64,1);
    }

    .goods-price span {
        font-size: 12px;
    }

    .goods-num {
        font-size: 12px;
    }
    .pay_order{
        width:87px;
        height:26px;
        background:linear-gradient(90deg,rgba(254,200,53,1) 0%,rgba(255,173,25,1) 100%);
        border-radius:13px;
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:26px;
        margin-right: 0.5rem
    }

    .row-btn {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        padding: 0.2rem 0.33rem;
        font-size: 12px;
        text-align: center;
        line-height: 0.52rem;
    }

    .look-order {
        font-size:12px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(0,0,0,1);
        line-height:26px;
        width:75px;
        height:26px;
        border-radius:13px;
        border:1px solid rgba(0,0,0,1);
        margin-right: 0.5rem;
    }

    .invite-btn {
        width: 2.1rem;
        height: 0.52rem;
        background: rgba(255, 0, 0, 1);
        border: 1px solid rgba(255, 0, 0, 1);
        border-radius: 4px;
        color: #fff;
    }

</style>

<script>
    import Vue from 'vue';

    import {Cell, CellGroup, Toast, Dialog, Icon, PullRefresh, List, Tag, Button,DropdownMenu, DropdownItem,
            Tab,
            Tabs,
            NoticeBar,
    } from 'vant';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Toast).use(Dialog).use(Icon).use(Tag).use(Button).use(DropdownMenu).use(Tab).use(Tabs).use(DropdownItem);
    export default {
        name: 'GoodsList',
        components: {
            [PullRefresh.name]: PullRefresh,
            [List.name]: List,
            LoginDialog
        },
        data: function () {
            return {
                loginShow: false,
                active: 0,
                isLoading: false,
                loading: false,
                finished: false,
                params: {
                    pageNo: 1,
                    pageSize: 5,
                    status: 0
                },
                homeTop : 0,
                list: [],
                userType:2
            }
        },
        mounted() {
            document.title = "报名记录"

            let that = this;
            // console.log(this.$route.meta)
            if (!this.$route.meta.isBack) {
                // 清空查询条件和数据
                that.list = [];
                that.active =0;
                that.params.pageNo = 1;
                that.params.status = 0;
                that.loading = true;
                that.finished = false;
                that.getList()

                if (this.$route.query.status) {
                    that.active = that.params.status = this.$route.query.status;
                    console.log(that.active)
                }
            }
            document.getElementById('app').scrollTop = this.homeTop || 0
            this.$route.meta.isBack = false;

        },
        destroyed() {
        },
        methods: {
            getList() {
                let that = this;
                that.$api.get('/api/qcxj/applylist', that.params, (res) => {
                    that.loading = false;

                    if (res.data.currentpage == 1) {
                        that.isLoading = false;
                        that.list = res.data.list
                    } else {
                        let list = that.list.concat(res.data.list);

                        that.list = list;
                    }

                    if (res.data.list.length == 0) {
                        that.finished = true;
                    }
                    that.params.pageNo += 1;
                }, (res) => {
                    if (res.code == 401 || res.code==402) {
                        if(window.isApp()){
                            rbLink({
                                name:'login','query':{ }
                            },'replace');
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },


            // 上拉加载
            // （页面显示没有更多了的原因 ）数据加载过慢 导致第一页数据未获取到时，已经请求第二页数据了
            // 可以延迟异步的时间
            onLoad() {
                // console.log(1)
                // 异步更新数据
                console.log('this.params.pageNo')

                if (this.params.pageNo > 1) {
                    setTimeout(() => {
                        this.getList()
                    }, 500);
                }

            },

            // 跳转订单详情
            goDetail(  order) {
                // 判断是否成团
                console.log( order)
                rbLink({
                    'name' : 'ExameApplyDetail',
                    'query':{
                        id: order.id
                    }
                } )

            },


            onRefresh() {
                let that = this;
                that.params.pageNo = 1;
                that.getList();
            },


            // 更改状态
            onStatusChange(index) {

                let that = this;
                that.params.status = index;
                that.params.pageNo = 1;

                // 激活下拉
                that.finished = false;
                that.loading = true;
                that.list = [];

                this.$route.query.status = 0;
                that.getList()
            },


            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// ExameApplyList.vue?33b2b21d